// @flow
import React from 'react';

import { CrisisAlert } from 'Components/widgets/crisis-alert/CrisisAlert.jsx';
import { SiteContainer } from 'Components/frameworks/site-container/SiteContainer.jsx';

type Props = {
  link: {
    label: string,
    url: string,
  },
  message: string,
  id?: string,
};

export function CrisisAlertLine({ id, ...props }: Props) {
  if (!props.message) {
    return null;
  }
  return (
    <SiteContainer id={id} className="Line">
      <CrisisAlert message={props.message} linkLabel={props.link.label} linkUrl={props.link.url} />
    </SiteContainer>
  );
}
